module.exports = __webpack_public_path__ + "static/fonts/iconfont.022bdab.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/iconfont/iconfont.ttf?t=1766389844018
// module id = HguW
// module chunks = 169